import React, { memo } from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import './TableCheckbox.css';

interface IProps {
  type: 'reviewed' | 'flagged' | 'follow';
  id: any;
  defaultChecked: boolean;
  onChange: (e: CheckboxChangeEvent, eventId: any) => void;
  isAdmin?: boolean;
}

const capitalizeFirst = (type: string) => {
  return type.charAt(0).toUpperCase() + type.slice(1);
};

const TableCheckbox: React.FC<IProps> = (props: IProps) => {
  const { type, id, defaultChecked, onChange, isAdmin } = props;

  const adminCheckbox: JSX.Element = (
    <Checkbox
      name={`${type}Checkbox`}
      defaultChecked={defaultChecked}
      className={`TableCheckbox TableCheckbox-${type}`}
      onChange={(e) => onChange(e, id)}
    >
      {capitalizeFirst(type)}
    </Checkbox>
  );

  const contributorCheckbox: JSX.Element = (
    <Checkbox
      name={`${type}Checkbox`}
      checked={defaultChecked}
      className={`TableCheckbox TableCheckbox-${type} TableCheckbox-contributor`}
    >
      {capitalizeFirst(type)}
    </Checkbox>
  );

  return isAdmin || type === 'follow' ? adminCheckbox : contributorCheckbox;
};

export default memo(TableCheckbox);
